import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiResponse,
  DictionaryField,
  DictionaryFieldFromApi,
} from '@gk/gk-modules';
import { BehaviorSubject, catchError, map } from 'rxjs';
import { handleApiError } from '../services.utils';

@Injectable()
export class DocumentSubjectService {
  documentSubjects = new BehaviorSubject<DictionaryField[]>([]);

  constructor(private httpClient: HttpClient) {
    this.fetchDocumentSubjectsList();
  }

  private fetchDocumentSubjectsList(): void {
    this.httpClient
      .get<ApiResponse<DictionaryFieldFromApi[]>>(
        '/api/srodowisko/slo/tematdok'
      )
      .pipe(
        map((data) => data.Response),
        map((documentSubjects) =>
          documentSubjects.map((documentSubject) =>
            DictionaryField.fromApiToApp(documentSubject)
          )
        ),
        catchError(handleApiError)
      )
      .subscribe((data) => this.documentSubjects.next(data));
  }
}
